import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type TenantUserAutocompleteSerializerType = {
  query: string;
  includeSelf: boolean;
  limit: number;
  strict: boolean;
};

export const apiFetchTenantUserAutocomplete = async ({
  domain = useTenantStore().domain,
  payload,
  errorConfig = {},
  callbacks = {},
  signal = null,
}: PostRequestArgsType<TenantUserAutocompleteSerializerType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.tenantUserAutocomplete({ domain }),
      payload,
      signal,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
